// extracted by mini-css-extract-plugin
export default {"alert":"ff7JTISD4XhJXUJNIbxs","align-left":"UhCgRYms03d18X6HhpU1","alertContent":"YVpzYYJ78VJk7t59fzrE","alertIcon":"ynPy47yHtgWEWv5PRPLS"};